(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-band"] && !Shopify.designMode) return;
  try {
    
  if(!window.whBandReady){
    window.whBandReady=true;
    document.addEventListener('click',(event)=>{
      const a=event.target.closest('[data-wh-band-black]');
      if(!a)return;
      const b=document.querySelector('#collection .wh-catalog-controls [data-wh-color="black"]');
      if(b&&b.getAttribute('aria-pressed')!=='true')b.click();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-catalog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',event=>{const button=event.target.closest('[data-catalog-colour]');if(!button)return;const section=button.closest('.wh-catalog');section.querySelectorAll('[data-catalog-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));section.querySelectorAll('wh-shop-card').forEach(card=>card.selectColour?.(button.dataset.catalogColour));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-collection"]) return;
  try {
    
  document.addEventListener('change',event=>{if(event.target.matches('.wh-sort-form select'))event.target.form.requestSubmit();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-footer"]) return;
  try {
    
  (function(){
    if(window.whSavedLinkReady) return; window.whSavedLinkReady=true;
    const read=()=>{try{return JSON.parse(localStorage.getItem('wh_saved')||'[]')}catch(e){return []}};
    function mount(){
      const right=document.querySelector('.wh-nav-right'); if(!right||right.querySelector('.wh-saved-link')) return;
      const a=document.createElement('a'); a.className='wh-saved-link'; a.href='/pages/saved'; a.setAttribute('aria-label','Saved pieces');
      a.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3S4.6 15.6 4.6 9.9a4.1 4.1 0 0 1 7.4-2.5 4.1 4.1 0 0 1 7.4 2.5c0 5.7-7.4 10.4-7.4 10.4z"/></svg><span data-wh-saved-count>(0)</span>';
      const bag=right.querySelector('.wh-bag-link'); right.insertBefore(a, bag||null); update();
    }
    function update(){const a=document.querySelector('.wh-saved-link'); if(!a) return; const n=read().length; a.dataset.count=n; a.querySelector('[data-wh-saved-count]').textContent='('+n+')';}
    document.addEventListener('wh:saved',update); window.addEventListener('storage',update);
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mount); else mount();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-giant-type"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const sections=document.querySelectorAll('[data-wh-giant]');if(!sections.length)return;
    let ticking=false;
    function update(){ticking=false;sections.forEach(s=>{const r=s.getBoundingClientRect();const vh=window.innerHeight;if(r.bottom<0||r.top>vh)return;const p=(r.top+r.height/2-vh/2)/vh;s.querySelectorAll('[data-wh-parallax]').forEach(el=>{const k=parseFloat(el.dataset.whParallax)||8;el.style.transform='translate3d(0,'+(p*k*-7).toFixed(1)+'px,0)';});});}
    window.addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(update);}},{passive:true});window.addEventListener('resize',update);update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-header"]) return;
  try {
    
  if(!customElements.get('wh-site-header'))customElements.define('wh-site-header',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.controller=new AbortController();const opts={signal:this.controller.signal};this.addEventListener('toggle',event=>{if(!event.target.matches('details'))return;if(event.target.open){this.querySelectorAll('details').forEach(d=>{if(d!==event.target)d.open=false;});if(event.target.matches('.wh-header-search'))event.target.querySelector('input[type=search]')?.focus();}},true);document.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=this.querySelector('details[open]');if(open){open.open=false;open.querySelector('summary').focus();}}},opts);document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('details').forEach(d=>d.open=false);},opts);this.addEventListener('click',e=>{if(e.target.closest('.wh-menu-panel a'))this.querySelector('.wh-mobile-menu').open=false;});window.addEventListener('pageshow',()=>this.refreshCart(),opts);document.addEventListener('shopify:cart:lines-update',event=>{event.promise?.then(()=>this.refreshCart()).catch(()=>{});},opts);document.addEventListener('shopify:cart:discount-update',event=>{event.promise?.then(()=>this.refreshCart()).catch(()=>{});},opts);}
    disconnectedCallback(){this.controller?.abort();this.ready=false;}
    async refreshCart(){try{const response=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();this.querySelector('[data-wh-bag-count]').textContent=`(${cart.item_count})`;}catch{}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-hero-video"] && !Shopify.designMode) return;
  try {
    
  (function(){const s=document.querySelector('[data-wh-hero-video]');if(!s)return;function fit(){if(window.scrollY>0)return;const top=Math.max(0,Math.round(s.getBoundingClientRect().top+window.scrollY));s.style.setProperty('--wh-hv-off',top+'px');}fit();window.addEventListener('resize',fit);window.addEventListener('load',fit);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-pdp-editorial"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('wh-colour-editorial'))customElements.define('wh-colour-editorial',class extends HTMLElement{
    connectedCallback(){this.controller=new AbortController();document.addEventListener('shopify:product:select',event=>{if(String(event.product?.id).split('/').pop()!==this.dataset.productId)return;const option=event.selectedOptions?.find(o=>o.name.toLowerCase()===this.dataset.option);if(!option)return;this.querySelectorAll('[data-editorial-colour]').forEach(photo=>photo.hidden=photo.dataset.editorialColour!==option.value.toLowerCase());},{signal:this.controller.signal});}
    disconnectedCallback(){this.controller?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-print-scroller"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const init=()=>{const sec=document.querySelector('[data-wh-ps]');if(!sec||sec.classList.contains('is-ready'))return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const track=sec.querySelector('.wh-ps-track'),stage=sec.querySelector('.wh-ps-stage'),slides=[...sec.querySelectorAll('.wh-ps-slide')],rail=[...sec.querySelectorAll('.wh-ps-rail i')];
    const n=slides.length;let cur=0,ticking=false,hd=0;
    function setHd(){const cand=[...document.querySelectorAll('#header-group, header, [class*="header"]')].find(e=>{const cs=getComputedStyle(e);return (cs.position==='sticky'||cs.position==='fixed')&&e.offsetHeight>30&&e.offsetHeight<260;});hd=cand?Math.round(cand.getBoundingClientRect().height):0;sec.style.setProperty('--wh-hd',hd+'px');}
    function update(){ticking=false;const r=track.getBoundingClientRect();const total=track.offsetHeight-stage.offsetHeight;if(total<=0)return;const y=Math.min(Math.max(hd-r.top,0),total);const pos=(y/total)*(n-1);const idx=Math.round(pos);const p=pos-idx;
      if(idx!==cur){slides.forEach((s,i)=>{s.classList.toggle('is-active',i===idx);s.classList.toggle('is-leaving',i===cur&&i<idx);});rail.forEach((el,i)=>el.classList.toggle('is-on',i<=idx));cur=idx;}
      slides[idx].style.setProperty('--p',p.toFixed(3));}
    const onScroll=()=>{if(!ticking){ticking=true;requestAnimationFrame(update);}};
    window.addEventListener('scroll',onScroll,{passive:true});document.addEventListener('scroll',onScroll,{passive:true,capture:true});window.addEventListener('resize',()=>{setHd();update();});
    sec.classList.add('is-ready');setHd();update();setTimeout(()=>{setHd();update();},600);};
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-saved"]) return;
  try {
    
  (function(){
    const grid=document.querySelector('[data-wh-saved-grid]'), empty=document.querySelector('[data-wh-saved-empty]');
    if(!grid) return;
    const KEY='wh_saved';
    const read=()=>{try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return []}};
    const esc=(s)=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
    function render(){
      const list=read();
      grid.hidden=list.length===0; empty.hidden=list.length>0;
      grid.innerHTML=list.map(i=>`<article class="wh-tile wh-saved-item" data-handle="${esc(i.handle)}"><a class="wh-tile-media" href="${esc(i.url)}"><span class="wh-tile-img"><img src="${esc(i.image)}" alt="${esc(i.title)}" loading="lazy"></span></a><div class="wh-tile-info"><div><p class="wh-tile-title"><a href="${esc(i.url)}">${esc(i.title)}</a></p><button type="button" class="wh-saved-remove" data-remove>Remove</button></div><span class="wh-tile-price">${esc(i.price)}</span></div></article>`).join('');
    }
    grid.addEventListener('click',e=>{const b=e.target.closest('[data-remove]');if(!b)return;const h=b.closest('[data-handle]').dataset.handle;const list=read().filter(i=>i.handle!==h);try{localStorage.setItem(KEY,JSON.stringify(list))}catch(err){}document.dispatchEvent(new CustomEvent('wh:saved',{detail:{count:list.length}}));render();});
    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
